import React, {lazy, Suspense} from 'react';
import {HashRouter, Route} from 'react-router-dom';
import {FormattedMessage} from 'react-intl';
import URL from '../../resources/constants/routes';
import Loader from '../Loader';

const ConsumerLoanSimulator = lazy(() => import('../../pages/ConsumerLoanSimulator'));
const ConsumerLoanSuccess = lazy(() => import('../../pages/ConsumerLoanSuccess'));

const routes = [
    {
        exact: true,
        path: URL.CONSUMER_LOAN_SUMULATOR,
        component: ConsumerLoanSimulator,
    },
    {
        exact: true,
        path: URL.CONSUMER_LOAN_SUCCESS,
        component: ConsumerLoanSuccess,
    }
];

const AppRouter = () => (
    <HashRouter>
        <Suspense fallback={<Loader />}>
            {routes.map(route => (
                <FormattedMessage key={route.path} id={route.path}>
                    {path => (
                        <Route
                            path={`/${path}`}
                            exact={route.exact}
                            component={route.component}
                        />
                    )}
                </FormattedMessage>
            ))}
        </Suspense>
    </HashRouter>
);

export default AppRouter;
